import React, {PureComponent} from "react"
import {SketchPicker, SketchPickerProps} from "react-color"

export interface Props extends SketchPickerProps {}

class ColorPicker extends PureComponent<Props> {
  render() {
    return <SketchPicker disableAlpha {...this.props} />
  }
}

export default ColorPicker
